import React from 'react';
import { bonuses } from '../data/bonuses';
export function Bonuses() {
  return <section className="bg-mist py-6 sm:py-9" data-id="element-19" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-[1080px] px-4 sm:px-6" data-id="element-20" data-mp="pjg4jxu631zc">
        <h2 className="text-center text-[23px] leading-none text-navy sm:text-[38px]" data-id="element-21" data-mp="avlb2f8c4tl7">
          🎁 5 professional bonuses <span className="text-diag" data-id="element-22" data-mp="ftej7dt77xo4">included</span>
        </h2>

        <div className="mt-4 grid gap-2.5 sm:gap-3 lg:grid-cols-2" data-id="element-23" data-mp="1uete2ty9cqd">
          {bonuses.map((bonus, i) => <article key={bonus.label} className={`flex flex-col rounded-md border border-gold/50 bg-white p-3.5 sm:p-4 ${i === bonuses.length - 1 ? 'lg:col-span-2' : ''}`} data-id="element-24" data-mp="5vqmwjfy2i3u" data-mpi={i}>
              <p className="w-fit rounded-sm bg-navy px-2 py-0.5 font-display text-[11.5px] font-semibold uppercase tracking-[0.14em] text-gold" data-id="element-25" data-mp="3t181lqn5uc4e">
                {bonus.label}
              </p>
              <h3 className="mt-1.5 text-[16px] leading-[1.1] text-navy sm:text-[20px]" data-id="element-26" data-mp="1r8tbw5edk3df">
                {bonus.title}
              </h3>
              <p className="mt-1 text-[12.5px] font-semibold uppercase tracking-wide text-steel" data-id="element-27" data-mp="3ic3kica096gx">
                {bonus.subtitle}
              </p>
              <p className="mt-1.5 text-[13.5px] font-medium leading-snug text-steel sm:text-[15px]" data-id="element-28" data-mp="3r5oyhtecijpa">
                {bonus.body}
              </p>
              <p className="mt-auto pt-2.5 font-display text-[13px] font-semibold uppercase tracking-wide text-diag" data-id="element-29" data-mp="3n7iv8vcpum94">
                {bonus.tagline}
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}